import firebaseChatService from '../services/firebaseChatService';
import wix from '../services/wix';
import { isExperimentOn } from '../reducers';
import { onVisitorMerge } from './visitorMerge';

const handleIncomingEvents = (event) => {
  return function (dispatch, getState) {
    if (
      event.type === 'VisitorMerge' &&
      getState().experimentsRaw[
        'specs.chat.NotifyVisitorMergeToCoreFirebaseSpec'
      ] === 'visitors'
    ) {
      return dispatch(onVisitorMerge(event));
    }
  };
};

interface InitFirebaseParams {
  initData: {
    authKey: string;
    options: object;
    messagePath: string;
    presencePath: string;
    visitorInstanceId: string;
    visitorId: string;
    correlationId: string;
    coreChatToken: string;
  };
  timestamp: number;
}

export const initFirebase = (action: InitFirebaseParams) => {
  return async function (dispatch, getState) {
    const {
      authKey,
      options,
      messagePath,
      presencePath,
      visitorInstanceId,
      visitorId,
      correlationId,
      coreChatToken,
    } = action.initData;
    const { timestamp } = action;
    await firebaseChatService.init({
      authKey,
      options,
      eventPath: messagePath,
      presencePath,
      biToken: wix.getBiToken(),
      instanceId: wix.getInstanceId(),
      visitorId,
      visitorInstanceId,
      correlationId,
      coreChatToken,
      presenceNGEnabled: isExperimentOn(getState(), 'specs.chat.PresenceNG'),
      isPresenceViaChatSdk: isExperimentOn(
        getState(),
        'specs.chat.PresenceViaChatSDK',
      ),
    });
    firebaseChatService.subscribeToEventsAndInfo({
      eventCallback: (events) => dispatch(handleIncomingEvents(events)),
      timestamp,
    });
    return firebaseChatService.removeOnDisconnect();
  };
};
